
import Vue from "vue";
import action from "@/components/ActionBarCom.vue";
import pageCom from "@/components/PageCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import Utils from "@/assets/js/Utils";
import dialogCom from "@/components/ModelCom.vue";
import delCom from "@/components/DelDataCom.vue";
import { StoreTypes } from "@/assets/js/Types";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
export default Vue.extend({
  components: { action, pageCom, dialogCom, delCom },
  data() {
    return {
      deviceTypes: this.$store.state.device[StoreTypes.XC_DEVICE_TYPE].filter(
        (x: any) => x.sid == 12
      ),
      delUrl: Urls.DelPolicy,
      currentSid: "",
      items: [] as any[],
      total: 0,
      pageSize: 6,
      currentPage: 1,
      searchStr: null as any,
      dialogTitle: {
        title: "新增策略",
      },
      projectForm: {
        sid: null,
        isTimmer: 0,
        timmerType: 0,
        actionType: 1,
        deviceTypeSid: "string",
        workMode: 1,
        chargeEnable: 1,
        chargeCur: 5,
        peakProtection: 0,
        undervoltageProtection: 0,
        exitProtection: 0,
        emergencyPercentage: 100,
        policyTimers: [
          {
            sid: Utils.GetGuid(),
            light: 0, //亮度
            policyTimerType: 1, //0-5 日出（落）前后，自定义时间Runmode
            startTime: "12:00", //自定义时间ExecTime
            startVal: 30, //Minute //经纬度偏移量
            startAction: 66, //Action  开灯 0x42(66)，关灯 0x43(67)
            powerSupply: 1, //Priority 0x01：蓄电池优先；0x02：市电优先
          },
        ],
        enabled: 1,
      } as any,
      current: null as any,
      projects: [] as any[],
      step: 0,
      policySEDate: [] as any[],
    };
  },
  async mounted() {
    await this.select();
  },
  methods: {
    policyTypeChange() {
      if (this.projectForm.policyType == 0) {
        this.projectForm.isTimmer = 2;
      } else {
        if (this.projectForm.deviceTypeSid == 1 || this.projectForm.deviceTypeSid == 8) {
          this.projectForm.isTimmer = 1;
        } else {
          this.projectForm.isTimmer = 0;
        }
      }
    },
    deviceTypeChange() {
      console.log(this.projectForm.deviceTypeSid);
      if (this.projectForm.deviceTypeSid == 1 || this.projectForm.deviceTypeSid == 8) {
        this.projectForm.oneAction = 1;
      } else {
        this.projectForm.oneAction = 0;
      }
    },
    addDateTime() {
      if (!this.projectForm.policyTimers) {
        this.projectForm.policyTimers = [];
      }
      if (
        this.projectForm.deviceTypeSid != 1 &&
        this.projectForm.deviceTypeSid != 8 &&
        this.projectForm.deviceTypeSid != 2 &&
        this.projectForm.policyTimers.length >= 6
      ) {
        throw "该设备一个策略仅支持6个时间段";
      } else {
        this.projectForm.policyTimers.push({
          sid: Utils.GetGuid(),
          startTime: "",
          endTime: "",
          startAction: 0,
          endAction: 0,
          startVal: 0,
          endVal: 0,
        });
        this.retSetOrder();
      }
    },
    addTimmer() {
      if (!this.projectForm.policyTimers) {
        this.projectForm.policyTimers = [];
      }
      this.projectForm.policyTimers.push({
        sid: Utils.GetGuid(),
        light: 0, //亮度
        policyTimerType: 1, //0-5 日出（落）前后，自定义时间Runmode
        startTime: "12:00", //自定义时间ExecTime
        startVal: 30, //Minute //经纬度偏移量
        startAction: 66, //Action  开灯 0x42(66)，关灯 0x43(67)
        powerSupply: 1, //Priority 0x01：蓄电池优先；0x02：市电优先
      });
      this.retSetOrder();
    },
    removeTimmer(sid: string) {
      let index = -1;
      for (let i = 0; i < this.projectForm.policyTimers.length; i++) {
        if (this.projectForm.policyTimers[i].sid == sid) {
          index = i;
        }
      }
      this.projectForm.policyTimers.splice(index, 1);
      this.retSetOrder();
    },
    retSetOrder() {
      let i = 1;
      this.projectForm.policyTimers.forEach((x: any) => {
        x.order = i;
        i += 1;
      });
    },
    SEChange() {
      this.projectForm.policyStart = this.policySEDate[0];
      this.projectForm.policyEnd = this.policySEDate[1];
    },
    async oneNext(step: number) {
      this.step = step;
    },
    async select() {
      const actionBar: any = this.$refs.action;
      this.searchStr = actionBar.getSearch();
      if (Utils.StringIsNull(this.searchStr)) {
        this.searchStr = null;
      }
      const ret = await DeviceRequestBill.GetPolicys(
        this.searchStr,
        this.currentPage,
        this.pageSize,
        4
      );
      this.items = ret.data;
      this.total = ret.total;
    },
    currentChange(val: any) {
      this.current = val;
    },
    insert() {
      this.step = 0;
      this.projectForm = {
        sid: null,
        isTimmer: 0,
        timmerType: 0,
        deviceTypeSid: "",
        enabled: true,
        workMode: 1,
        chargeEnable: 1,
        chargeCur: 3.5,
        peakProtection: 25.2,
        undervoltageProtection: 17.5,
        exitProtection: 18,
        emergencyPercentage: 10,
        policyTimers: [],
      };
      this.dialogTitle.title = "新增策略";
      const dialog: any = this.$refs.projectDialog;
      dialog.show();
    },
    closeDialog() {
      const dialog: any = this.$refs.projectDialog;
      dialog.hiden();
    },
    async modify() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.dialogTitle.title = "修改策略";
      const reslut = await DeviceRequestBill.GetPolicyDetail(this.current.sid);
      this.projectForm = reslut;
      if (this.projectForm.policyTimers) {
        this.projectForm.policyTimers.forEach((x: any) => {
          (x.startTime = new Date(`2020/01/01 ${x.startTime || "00:00:00"}`)),
            (x.endTime = new Date(`2020/01/01 ${x.endTime || "00:00:00"}`));
        });
      }
      this.step = 0;
      this.policySEDate = [this.projectForm.policyStart, this.projectForm.policyEnd];
      const dialog: any = this.$refs.projectDialog;
      dialog.show();
      this.deviceTypeChange();
    },
    del() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.currentSid = this.current.sid;
      const dialog: any = this.$refs.del;
      dialog.show();
    },
    ex() {
      //
    },
    inport() {
      //
    },
    search() {
      this.select();
    },
    searchChanged(str: string) {
      this.searchStr = str;
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.select();
    },
    async onSubmit() {
      if (!this.projectForm.policyLoops) {
        this.projectForm.policyLoops = [];
      }
      this.projectForm.policyStart = Utils.FormatData(new Date());
      this.projectForm.policyEnd = Utils.FormatData(new Date());
      if (this.projectForm.policyTimers && this.projectForm.policyTimers.length != 0) {
        this.projectForm.policyTimers.forEach((x: any) => {
          x.startTime = Utils.FormatData(x.startTime);
          x.endTime = Utils.FormatData(x.startTime);
        });
      }
      if (!this.projectForm.sid) {
        await HttpUtil.XCHttpPost(Urls.AddPolicy, this.projectForm, true, false);
      } else {
        await HttpUtil.XCHttpPost(Urls.UpdatePolicy, this.projectForm, true, false);
      }
      this.closeDialog();
      this.select();
    },
  },
});
